import React from 'react';
import { processMarkup } from "./core/ProcessMarkup";
import handleCrawlers from "./core/handleCrawlers";

//Handle bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

isCrawler && handleCrawlers();

processMarkup();